import { FC, useCallback, useContext, useMemo } from 'react';

import { useModals } from '@mantine/modals';
import Picker from 'emoji-picker-react';
import { isMobile } from 'react-device-detect';
import { RichTextEditor, ToolbarHandler } from '../Rte/components/RichTextEditor/RichTextEditor';
import { CustomModalHeader } from '../../Molecules/Dialogs';
import { ProfileContext } from '../../Service/Context/ProfileContext';
import BookingEvent from '../../Types/Event';
import { RteInputContext } from './rte/RteInputContext';

type Props = {
  event: BookingEvent;
  disabled?: boolean;
};

const PlaceholderRteInputField: FC<Props> = ({ event, disabled }) => {
  const {
    ref,
    controls,
    mentions,
    displayValue,
    show,
    onDisplayValueChanged,
    onEmojiClick,
    onBlurCallback,
    onFocusCallback,
    toggle,
  } = useContext(RteInputContext);

  const { openContextModal } = useModals();

  const { profile } = useContext<any>(ProfileContext);

  const openInsertPortalLink = useCallback(
    () =>
      openContextModal('insertPortalLink', {
        title: <CustomModalHeader>Portal-Zugang erstellen</CustomModalHeader>,
        innerProps: {
          profile,
          eventId: event ? event.id : undefined,
        },
        centered: true,
        size: 'xl',
      }),
    [event, openContextModal, profile],
  );

  const additionalToolbarHandlers = useMemo<Record<string, ToolbarHandler | undefined>>(
    () =>
      isMobile
        ? { portalLink: openInsertPortalLink }
        : {
            portalLink: openInsertPortalLink,
            emoji: toggle,
          },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  return (
    <div style={{ display: 'flex', flexDirection: 'row' }}>
      <RichTextEditor
        ref={ref}
        value={displayValue}
        onChange={onDisplayValueChanged}
        onFocus={onFocusCallback}
        onBlur={onBlurCallback}
        formats={['bold', 'italic', 'underline', 'link', 'mention']}
        id="rte"
        controls={controls}
        additionalToolbarHandlers={additionalToolbarHandlers}
        mentions={mentions}
        style={{ minHeight: 300, flex: '2 1 auto' }}
        readOnly={disabled}
      />
      {!isMobile && show && (
        <div style={{ marginLeft: '10px' }}>
          <Picker onEmojiClick={onEmojiClick} disableSearchBar pickerStyle={{ position: 'relative' }} />
        </div>
      )}
    </div>
  );
};

export default PlaceholderRteInputField;
